import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastNotificationService {
form = new BehaviorSubject({title:'',message:''})
formError = new BehaviorSubject({title:'',message:''})


  constructor() { }

  success(message:string,title:string){
    if(title === '')
    title = "Success"
    this.form.next({title:title,message:message})
  }
  error(message:string,title:string){
    if(title === '')
    title = "Error"
    this.formError.next({title:title,message:message})
  }
  getSucess(){
    return this.form.asObservable();
  }
  getError(){
    return this.formError.asObservable();
  }
}
